export default [
    {
        title: '英国保诚集团（Prudential）',
        body: '英国最大的保险公司，更是英国最大的投资机构，拥有超过一千二百五十项产业，总值超过七十亿美金。 保诚集团更是英国最大的投资机构，通过集团全资附属投资公司的英国保诚资产管理公司（Prudential Portfolio Managers，简称PPM），在全球管理的基金总额超过二千一百亿美元，而PPM驻港办事处则管理亚洲区超过一百二十亿美元的资产，投资项目包括股票、地产及基础设施等。'
    },
    {
        title: '东亚银行（The Bank of East Asia）',
        body: '东亚银行是香港最大的独立本地银行，综合资产总额达港币7,540亿元，是恒生指数成分股之一。东亚银行凭借深厚的全球经验，根据本地客户的特点，按照他们的财富管理需求、金融需要及风险承受水平，提供具有国际一流水平的金融产品和服务，满足其多样化的金融需求。'
    },
    {
        title: '汇丰银行（HSBC）',
        body: '香港上海汇丰银行有限公司（The Hongkong and Shanghai Banking Corporation Limited，英文缩写HSBC）为汇丰控股有限公司的全资附属公司，属于汇丰集团的创始成员以及在亚太地区的旗舰，也是香港最大的注册银行，以及香港三大发钞银行之一，在亚太地区设立约700多间分行及办事处。2008年度世界500强第20位，收入1465亿美元，净利润191.33亿美元。'
    },
    {
        title: '摩根大通集团（JPMorgan Chase & Co.）',
        body: '摩根大通集团，业界称西摩或小摩，总部在美国纽约，总资产2.5万亿美元，总存款高达1.5万亿美元，占美国存款总额的25%，分行6000多家，是美国最大金融服务机构之一，摩根大通于2000年由大通曼哈顿银行及J.P.摩根公司合并而成，并分别收购芝加哥第一银行和贝尔斯登银行和华盛顿互惠银行。'
    },
    {
        title: '普华永道会计师事务所（PricewaterhouseCoopers',
        body: '普华永道会计师事务所（是世界上最顶级的会计师事务所之一。普华永道在2008财年获利约280亿美元，它的雇员超过146,000人，遍布150个国家或地区。在福布斯全球排行榜上，普华永道位列全球企业的第三名，普华永道也是国际四大会计师事务所之一'
    },
    {
        title: '中信证券股份有限公司（CITIC）',
        body: '中信证券股份有限公司，是中国证监会核准的第一批综合类证券公司之一。主营业务范围为：证券、客户资产管理、投资咨询、财务顾问等。在大陆境内拥有165家证券营业部、61家证券服务部和4家期货营业部。'
    }
]



// WEBPACK FOOTER //
// ./src/data/companyinfo.js